import { useCreatePortfolio } from './CreatePortfolioManager';

export const useCreatePortfolioSelectors = () => {
    const { selectors } = useCreatePortfolio();

    return selectors;
};
